import { z } from 'zod';
import { modeSchema } from '../schemas/theme.schema';
import type { Theme } from './theme.types';

export const themePreferenceSchema = z.enum(['Blossom', 'Dew', 'Cherry', 'Golden', 'roast']);
export type ThemePreference = z.infer<typeof themePreferenceSchema>;

export const saveThemePreferenceSchema = z.object({
	theme: themePreferenceSchema,
	mode: modeSchema,
});
export type SaveThemePreference = z.infer<typeof saveThemePreferenceSchema>;

export const themePreferenceResponseSchema = z.object({
	theme: themePreferenceSchema.nullish(),
	mode: modeSchema.nullish(),
});
export type ThemePreferenceResponse = z.infer<typeof themePreferenceResponseSchema>;

export const THEME_PREFERENCE_TO_THEME = {
	Blossom: 'florada',
	Dew: 'orvalho',
	Cherry: 'cereja',
	Golden: 'dourado',
	roast: 'torra',
} as const satisfies Record<ThemePreference, Theme>;

export const THEME_TO_THEME_PREFERENCE = {
	florada: 'Blossom',
	orvalho: 'Dew',
	cereja: 'Cherry',
	dourado: 'Golden',
	torra: 'roast',
} as const satisfies Record<Theme, ThemePreference>;
